export default __webpack_public_path__ + "static/joannam-7daf925f82e7092f395579b8ae6e50ca.png";